import { Injectable } from '@angular/core';
import { Cooper } from '../interfaces/cooper';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CooperCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/settings/coopers/' ;
  }

  // Create Cooper
  add(record: Cooper) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Cooper Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Coopers List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Cooper Object
  update(record: Cooper) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Cooper>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Cooper Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}
